/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketMessageViewModel } from '../../models/support-ticket-message-view-model';

export interface EditMessage$Params {
      body?: {
'messageID'?: number;
'message'?: string;
}
}

export function EditMessage(http: HttpClient, rootUrl: string, params?: EditMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketMessageViewModel>> {
  const rb = new RequestBuilder(rootUrl, EditMessage.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketMessageViewModel>;
    })
  );
}

EditMessage.PATH = '/api/Tickets/EditMessage';
